export default __webpack_public_path__ + "static/media/sa.bba81f58.svg";